import { createContext, useContext, useState } from "react";

const CompareContext = createContext();

export function CompareProvider({ children }) {
  // ALWAYS store full product objects
  const [selected, setSelected] = useState([]);
  // selected = [{ _id, title, imgsrc, rating, op, description }]
  let trayHeight = 390;
  // mobile
  if (window.innerWidth < 480) trayHeight = 450;
  // very small (icons wrap)
  if (window.innerWidth < 360) trayHeight = 280;
  const add = (product) => {
    if (!product || !product._id) return;

    setSelected((prev) => {
      // prevent duplicates
      if (prev.some((p) => p._id === product._id)) return prev;

      // max 5 items
      if (prev.length >= 5) return prev;

      // store full object
      return [...prev, product];
    });
  };

  const remove = (id) => {
    setSelected((prev) => prev.filter((p) => p._id !== id));
  };

  const clear = () => setSelected([]);

  return (
    <CompareContext.Provider value={{ selected, add, remove, clear }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  return useContext(CompareContext);
}
